export const TAB_VALUE = Object.freeze({
    CONVERSATIONS: "conversations",
    DRAFTS: "drafts",
    COMMENTS: "internal-comments",
    HISTORY: "history",
});

export const TAB_VALUE_LABEL = Object.freeze({
    "internal-comments": "Internal Comments",
});

export const SURVEY_EMOJIS = Object.freeze({
    HAPPY: "😊",
    NEUTRAL: "😐",
    SAD: "😞",
    NOT_ANSWERED: "❓"
})
